<div class="graphic-container">
  <h3 class="graphic-title" [innerHTML]="headline" *ngIf="headline"></h3>
  <div
    class="graphic-content"
    [ngStyle]="{
      'background-color': backgroundColor,
      padding: isTransparent() ? '0' : '1rem',
    }"
  >
    <ng-container *ngFor="let src of getImageSources()">
      <hdi-image
        [src]="desktopImageSrc"
        [mobileSrc]="mobileImageSrc"
        [alt]="alt"
        [title]="title"
        [viewport]="viewport"
      />
    </ng-container>
  </div>
</div>
